/* eslint-disable implicit-arrow-linebreak */
// ** Router Import
import { useState } from "react"
import Router from "./router/Router"
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"

const App = props => {
  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(process.env.REACT_APP_STRIPE_KEY)
  )

  return (
    <Elements stripe={stripePromise}>
      <Router />
    </Elements>
  )
}

export default App
